export default __webpack_public_path__ + "static/media/coding.d971fd80.gif";